export class ChangeTermsPurchaseField {
    label: string;
    name: string;
    type: string;
    value: string = '';

    // public constructor(label: string, name: string, type: string, value: string) {
    public constructor(label: string, name: string, type: string, value: string) {
        this.label = label;
        this.name = name;
        this.type = type;
        this.value = value;
    }

    public change(field: any) {
        this.value = field.value;
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/change-terms-purchase/change-terms-purchase-field.ts